"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isCollectionShape = void 0;

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var isCollectionShape = function isCollectionShape(object) {
  if (!object || _typeof(object) !== 'object') {
    return false;
  }

  if (Object.keys(object).length !== 1) {
    return false;
  }

  var collectionKey = Object.keys(object)[0];

  if (!collectionKey.match(/\w+Collection/)) {
    return false;
  }

  if (!object[collectionKey].items) {
    return false;
  }

  if (!Array.isArray(object[collectionKey].items)) {
    return false;
  }

  return true;
};

exports.isCollectionShape = isCollectionShape;